import React, { useState } from 'react';
import { Button } from 'antd';

import { BaseModal, BaseModalFooter } from 'components/wrappers/BaseModal';
import { useAppDispatch } from 'hooks/useAppDispatch';
import BaseAlert from 'components/wrappers/BaseAlert';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import { updateStatusTwoFA } from 'redux/reducers/authenticationSlice';

import styles from './DisableTwoFAModal.module.less';

type Props = {
  onClose: () => void;
  onReset: (status: boolean) => void;
};

export default function DisableTwoFAModal(props: Props) {
  const { onClose, onReset } = props;
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useAppDispatch();

  const handleDisableTwoFA = async () => {
    setIsLoading(true);

    const result = await dispatch(updateStatusTwoFA({ is2FAStatus: false }));

    if (updateStatusTwoFA.fulfilled.match(result)) {
      BaseAlert.success('Email authentication was successfully disabled.');
      onClose();
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
    setIsLoading(false);
  };

  const handleCloseModal = () => {
    onReset(true);
    onClose();
  };

  return (
    <BaseModal
      title="Disable Two-Factor Email Authentication"
      onCancel={handleCloseModal}
      maxWidth={454}
      open
    >
      <div className="modal-scroll-wrapper">
        <div className={styles.disableModalText}>
          Are you sure you want to disable the two-factor authentication? For
          security reasons, it is recommended to keep this setting enabled.
        </div>
      </div>
      <BaseModalFooter>
        <Button onClick={handleCloseModal}>Cancel</Button>
        <Button type="primary" onClick={handleDisableTwoFA} loading={isLoading}>
          Disable
        </Button>
      </BaseModalFooter>
    </BaseModal>
  );
}
